import { AspectRatio } from '@nwwp/ui-shadcn/components/aspect-ratio'
import { cn } from '@nwwp/ui-shadcn/lib/utils'

type ImagePlaceholderProps = {
  label: string
  description?: string
  /** Aspect ratio as width/height (e.g. 16/9). Default 16/9. */
  ratio?: number
  className?: string
}

/**
 * Labeled blank for mockup imagery that was not supplied as a file.
 * Prefer this over substituting a library image.
 */
function ImagePlaceholder({
  label,
  description = 'Asset to be supplied',
  ratio = 16 / 9,
  className,
}: ImagePlaceholderProps) {
  return (
    <AspectRatio ratio={ratio} className={cn('w-full', className)}>
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-1 rounded-xl border border-dashed border-border bg-muted/40 p-4 text-center tablet:p-6 size-full">
        <p className="text-body-sm-bold text-foreground">{label}</p>
        <p className="text-body-sm text-muted-foreground">{description}</p>
      </div>
    </AspectRatio>
  )
}

export { ImagePlaceholder }
export type { ImagePlaceholderProps }
